/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

export interface CollapsibleCardSignature {
  Blocks: {
    content: [];
    title: [];
  };
}

export default templateOnlyComponent<CollapsibleCardSignature>();
